import { useIntl } from 'react-intl';

export default function useAlignmentStatus() {
  const intl = useIntl();

  const ALIGNED = intl.formatMessage({
    defaultMessage: 'Aligns with video',
    id: '04b36',
  });
  const MIS_ALIGNED = intl.formatMessage({
    defaultMessage: 'Misaligned with video',
    id: '7d981',
  });
  const ALIGNMENT_STATUS_NOT_KNOWN = intl.formatMessage({
    defaultMessage: 'Alignment Status Unknown',
    id: '115ad',
  });

  const calculateIsAligned = (event, playlistEntry) =>
    event?.isAligned != null ? event.isAligned : playlistEntry?.isAligned;

  const calculateAlignmentStatus = (event, playlistEntry) => {
    const isAligned = calculateIsAligned(event, playlistEntry);

    if (isAligned == null) {
      return ALIGNMENT_STATUS_NOT_KNOWN;
    }
    return isAligned ? ALIGNED : MIS_ALIGNED;
  };

  return {
    calculateAlignmentStatus,
    calculateIsAligned,
  };
}
